var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-10 col-md-7 col-lg-4 d-flex align-items-stretch" },
    [
      _c("div", { staticClass: "card blog__item overflow-hidden" }, [
        _c("div", { staticClass: "card-image" }, [
          _c("a", { attrs: { href: _vm.guid, target: "_blank" } }, [
            _c("img", {
              staticClass: "img-fluid",
              attrs: { src: _vm.featuredImageUrl }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row align-items-center mb-4" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("a", { attrs: { href: _vm.guid } }, [
                _c("h5", [_vm._v(_vm._s(_vm.title))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("span", { staticClass: "text-muted" }, [
                _vm._v(
                  "\n\t\t\t\t\t\t\t" +
                    _vm._s(_vm.formattedDate) +
                    "\n\t\t\t\t\t\t"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-info" }, [
            _c("p", [_vm._v(_vm._s(_vm.formattedDescription))])
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "text-secondary",
              attrs: { href: _vm.guid, target: "_blank" }
            },
            [_vm._v("Read More")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }